import React, { useMemo } from 'react';
import Badge from '../../../components/ui/Badge';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import {
  ReferenceDataGeneralList,
  type ReferenceInboxColumn,
} from '../../parameters/ReferenceDataGeneralList';
import { formatPeriodStatus, isPeriodLocked, moduleConfig } from './config';
import { useAccPeriods, type AccPeriod } from './useData';

const List: React.FC = () => {
  const { colors } = useTheme();
  const formatDate = moduleConfig.utils.formatDate;

  const columns = useMemo<ReferenceInboxColumn<AccPeriod>[]>(
    () => [
      {
        key: 'year',
        header: 'Year',
        className: 'whitespace-nowrap',
        render: (row) => <span className={cn('font-medium tabular-nums', colors.text)}>{row.year}</span>,
      },
      {
        key: 'startDate',
        header: 'Start',
        className: 'hidden whitespace-nowrap sm:table-cell',
        render: (row) => <span className={colors.textMuted}>{formatDate(row.startDate)}</span>,
      },
      {
        key: 'endDate',
        header: 'End',
        className: 'hidden whitespace-nowrap sm:table-cell',
        render: (row) => <span className={colors.textMuted}>{formatDate(row.endDate)}</span>,
      },
      {
        key: 'status',
        header: 'Status',
        className: 'whitespace-nowrap',
        render: (row) => (
          <Badge variant={row.status === 'OPEN' ? 'success' : 'warning'}>
            {formatPeriodStatus(row.status)}
          </Badge>
        ),
      },
    ],
    [colors.text, colors.textMuted, formatDate],
  );

  return (
    <ReferenceDataGeneralList
      moduleConfig={moduleConfig}
      useData={useAccPeriods}
      columns={columns}
      defaultSort={{ key: 'year', direction: 'desc' }}
      newLabel="New period"
      getRowLabel={(row) => String(row.year)}
      activeTabs={false}
      canEditRow={(row) => !isPeriodLocked(row)}
      canDeleteRow={(row) => !isPeriodLocked(row)}
      loadingLabel="Loading periods…"
    />
  );
};

export default List;
